const ACTIVITIES = [
  {
    image: "/img/dernek_ici.jpeg",
    title: "Esen Sofrasındayız",
    infos: [
      { icon: "fa-users", text: "35 Katılımcı" },
      { icon: "fa-list", text: "4 Karar" },
    ],
    description:
      "Ankara Ağrılılar Derneği olarak hemşehrilerimizi aynı sofrada buluşturup güçlü bir dayanışma ağı kurmayı hedefliyoruz.",
    cta: "Kayıt Ol",
  },
  {
    image: "/img/kolaj1.jpg",
    title: "Hemşehri İstişare Toplantısı",
    infos: [
      { icon: "fa-users", text: "75 Katılımcı" },
      { icon: "fa-list", text: "Gündem" },
    ],
    description:
      "Ankara’daki Ağrılıları, ilçe dernekleri ve hemşehri gruplarıyla birlikte ortak dayanışma çatısında buluşturmak için toplantılar düzenliyoruz.",
    cta: "Kayıt Ol",
  },
  {
    image: "/img/activities/robotics-kids.jpg",
    title: "Robotik Programlama Eğitimi",
    infos: [
      { icon: "fa-users", text: "Çocuklar" },
      { icon: "fa-list", text: "Teknoloji" },
    ],
    description:
      "Çocuklarımızın kodlama, problem çözme ve üretme becerilerini geliştirmesi için robotik ve teknoloji atölyeleri düzenliyoruz.",
    cta: "Çocuklarını Kaydet",
  },
  {
    image: "/img/about-4.jpg",
    title: "Aile Pikniği ve Tanışma Günü",
    infos: [
      { icon: "fa-users", text: "Aileler" },
      { icon: "fa-list", text: "Sosyal" },
    ],
    description:
      "Çocukların oynadığı, ailelerin tanıştığı ve hemşehrilerimizin sıcak bir ortamda sohbet ettiği piknik buluşmaları planlıyoruz.",
    cta: "Katıl",
  },
  {
    image: "/img/activities/robotics-table.jpg",
    title: "Çocuklar İçin Eğitim Atölyeleri",
    infos: [
      { icon: "fa-users", text: "Öğrenciler" },
      { icon: "fa-list", text: "Eğitim" },
    ],
    description:
      "İngilizce, temel bilgisayar, yazılım, ödev desteği ve okul motivasyonu gibi başlıklarda çocuklarımızı destekliyoruz.",
    cta: "Bilgi Al",
  },
  {
    image: "/img/activities/social-support.jpg",
    title: "Sosyal Destek ve Yardımlaşma",
    infos: [
      { icon: "fa-users", text: "Aileler" },
      { icon: "fa-list", text: "Destek" },
    ],
    description:
      "İhtiyaç sahibi hemşehrilerimiz için gıda, kıyafet, eğitim malzemesi ve acil destek süreçlerinde dayanışma organizasyonu yapıyoruz.",
    cta: "Destek Ol",
  },
  {
    image: "/img/dernek_ici.jpeg",
    title: "Danışmanlık ve Destek Masası",
    infos: [
      { icon: "fa-users", text: "Uzmanlar" },
      { icon: "fa-list", text: "Danışmanlık" },
    ],
    description:
      "Sağlık, hukuk, iş, eğitim ve resmi işlemler konusunda desteğe ihtiyaç duyan hemşehrilerimizi gönüllü uzmanlarla buluşturuyoruz.",
    cta: "Talep Oluştur",
  },
  {
    image: "/img/activities/business-meeting.jpg",
    title: "Esnaf ve İş İnsanları Buluşması",
    infos: [
      { icon: "fa-users", text: "Esnaflar" },
      { icon: "fa-list", text: "İş Ağı" },
    ],
    description:
      "Ankara’daki Ağrılı esnafları ve iş insanlarını tanıştırarak müşteri, istihdam ve iş birliği fırsatlarını güçlendiriyoruz.",
    cta: "Firmamı Ekle",
  },
  {
    image: "/img/about-1.jpg",
    title: "Ağrı Tanıtım Günleri",
    infos: [
      { icon: "fa-users", text: "Herkes" },
      { icon: "fa-list", text: "Tanıtım" },
    ],
    description:
      "Ağrı Dağı, İshak Paşa Sarayı, yöresel lezzetler, ilçeler ve hemşehri kültürümüzü Ankara’da daha görünür kılacak tanıtım programları hazırlıyoruz.",
    cta: "Katıl",
  },
  {
    image: "/img/activities/cultural-dance.jpg",
    title: "Kültür Gecesi ve Halk Oyunları",
    infos: [
      { icon: "fa-users", text: "Gençler" },
      { icon: "fa-list", text: "Kültür" },
    ],
    description:
      "Yöresel müzik, halk oyunları, şiir, dengbej geleneği ve aile buluşmalarıyla Ağrı kültürünü Ankara’da yaşatıyoruz.",
    cta: "Katıl",
  },
  {
    image: "/img/about-2.jpg",
    title: "Taziye ve Dayanışma Organizasyonu",
    infos: [
      { icon: "fa-users", text: "Aileler" },
      { icon: "fa-list", text: "Destek" },
    ],
    description:
      "Zor zamanlarda ailelerimizin yanında olmak için taziye yeri, duyuru, ulaşım ve ihtiyaç koordinasyonu konusunda destek sağlıyoruz.",
    cta: "Bilgi Al",
  },
  {
    image: "/img/kolaj2.jpg",
    title: "Kadın Kolları Buluşmaları",
    infos: [
      { icon: "fa-users", text: "Kadınlar" },
      { icon: "fa-list", text: "Sosyal" },
    ],
    description:
      "Kadınlarımızın üretim, dayanışma, aile eğitimi, el emeği ve sosyal projelerde daha görünür olması için düzenli buluşmalar yapıyoruz.",
    cta: "Katıl",
  },
  {
    image: "/img/dernek_ici.jpeg",
    title: "Gençlik Kariyer Buluşmaları",
    infos: [
      { icon: "fa-users", text: "Gençler" },
      { icon: "fa-list", text: "Kariyer" },
    ],
    description:
      "Üniversite öğrencileri ve işe hazırlanan gençler için CV, mülakat, staj, mentorluk ve meslek tanıtımı buluşmaları düzenliyoruz.",
    cta: "Başvur",
  },
  {
    image: "/img/activities/social-support.jpg",
    title: "Burs ve Eğitim Desteği",
    infos: [
      { icon: "fa-users", text: "Öğrenciler" },
      { icon: "fa-list", text: "Burs" },
    ],
    description:
      "Başarılı ve desteğe ihtiyaç duyan öğrencilerimiz için burs, kırtasiye, rehberlik ve eğitim desteği süreçlerini takip ediyoruz.",
    cta: "Destek Ver",
  },
  {
    image: "/img/activities/business-meeting.jpg",
    title: "Firma Tanıtım ve İş Birliği Günü",
    infos: [
      { icon: "fa-users", text: "Firmalar" },
      { icon: "fa-list", text: "Tanıtım" },
    ],
    description:
      "Ağrılı firmaların ürün ve hizmetlerini tanıtması, yeni müşterilere ulaşması ve güvenilir iş bağlantıları kurması için alan açıyoruz.",
    cta: "Firmamı Tanıt",
  },
  {
    image: "/img/about-3.jpg",
    title: "Memleket Söyleşileri",
    infos: [
      { icon: "fa-users", text: "Herkes" },
      { icon: "fa-list", text: "Söyleşi" },
    ],
    description:
      "Ağrı’nın tarihi, ilçeleri, aile hafızası, göç hikayeleri ve kültürel mirası üzerine konuşmalar ve sohbet programları yapıyoruz.",
    cta: "Bilgi Al",
  },
]

export default ACTIVITIES
